import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
export default class BirthdayNotification extends Notification {
  icon() {
    return 'fas fa-cake-candles';
  }
  href() {
    return app.route.user(this.attrs.notification.subject());
  }
  content() {
    return app.translator.trans('datlechin-birthdays.forum.notifications.birthday_text', {
      forum: app.forum.attribute('title')
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('datlechin-birthdays', 'forum/components/BirthdayNotification', BirthdayNotification);